
import { FormItem } from 'element-ui'

export default {
  extends: FormItem,
}
